import React, { Component } from "react";
import { Fade } from "react-reveal";
import { donationsData, greeting } from "../../portfolio.js";
import Button from "../../components/button/Button";
import "./DonationsSection.css";
import { useLanguage } from "../../context/LanguageContext";
import { getTranslation } from "../../translations/translations";

const DonationsContent = ({ theme }) => {
  const { language } = useLanguage();

  return (
    <div className="donations-main">
      <div className="donations-header">
        <Fade bottom duration={1000} distance="40px">
          <h1 className="donations-heading" style={{ color: theme.text }}>
            {getTranslation(language, "support_our_church")}
          </h1>
          <p
            className="donations-subtitle"
            style={{ color: theme.secondaryText }}
          >
            {getTranslation(language, "help_build_church")}
          </p>
        </Fade>
      </div>

      <div className="donations-content">
        {/* GiveALittle Section */}
        <Fade bottom duration={1500} distance="40px">
          <div className="donation-card donate-card">
            <div className="donation-method-icon">💚</div>
            <h3 style={{ color: theme.text }}>
              {getTranslation(language, "donate_online")}
            </h3>
            <p style={{ color: theme.secondaryText }}>
              {getTranslation(language, "help_build_church")}
            </p>
            <Button
              text={getTranslation(language, "donate_givealittle")}
              href={donationsData.giveALittleLink}
              newTab={true}
              theme={theme}
            />
          </div>
        </Fade>

        {/* Bank Transfer Section */}
        <Fade bottom duration={1500} distance="40px">
          <div className="donation-card bank-card">
            <div className="donation-method-icon">🏦</div>
            <h3 style={{ color: theme.text }}>
              {getTranslation(language, "bank_transfer")}
            </h3>
            <div className="bank-details">
              <p>
                <strong style={{ color: theme.text }}>Bank:</strong>
                <span style={{ color: theme.secondaryText }}>
                  {" "}
                  {donationsData.bankDetails.bankName}
                </span>
              </p>
              <p>
                <strong style={{ color: theme.text }}>
                  {getTranslation(language, "contact_us_heading")}:
                </strong>
                <span style={{ color: theme.secondaryText }}>
                  {" "}
                  {donationsData.bankDetails.accountName}
                </span>
              </p>
              <p>
                <strong style={{ color: theme.text }}>
                  {getTranslation(language, "account_number")}:
                </strong>
                <span
                  style={{ color: theme.secondaryText }}
                  className="copyable"
                >
                  {" "}
                  {donationsData.bankDetails.accountNumber}
                </span>
              </p>
              <p>
                <strong style={{ color: theme.text }}>
                  {getTranslation(language, "reference")}:
                </strong>
                <span style={{ color: theme.secondaryText }}>
                  {" "}
                  {donationsData.bankDetails.referenceNumber}
                </span>
              </p>
            </div>
          </div>
        </Fade>

        {/* Email Section */}
        <Fade bottom duration={1500} distance="40px">
          <div className="donation-card email-card">
            <div className="donation-method-icon">📧</div>
            <h3 style={{ color: theme.text }}>
              {getTranslation(language, "contact_us")}
            </h3>
            <p style={{ color: theme.secondaryText }}>
              {getTranslation(language, "contact_support")}
            </p>
            <a
              href="mailto:tsirhatsion.nz@gmail.com"
              className="contact-link"
              style={{ color: theme.highlight }}
            >
              {getTranslation(language, "get_in_touch")} →
            </a>
          </div>
        </Fade>
      </div>

      {/* GiveALittle Widget - Separate Full-Width Section */}
      <Fade bottom duration={1500} distance="40px">
        <div className="givealittle-widget-section">
          <iframe
            width="100%"
            height="350"
            src="https://givealittle.co.nz/widget/dark-starbuck/org/ethiopian-orthodox-tewahido-church"
            frameBorder="0"
            seamless="seamless"
            style={{ border: "none" }}
            title="GiveALittle Donation Widget"
          />
        </div>
      </Fade>

      <div className="donations-footer">
        <Fade bottom duration={2000} distance="40px">
          <p style={{ color: theme.secondaryText }}>
            {getTranslation(language, "thank_you_donation")}
          </p>
        </Fade>
      </div>
    </div>
  );
};

class DonationsSection extends Component {
  render() {
    return <DonationsContent theme={this.props.theme} />;
  }
}

export default DonationsSection;
